'use strict';

function getFirstWarrantyOption(optionUuid, dealOptionWarranties = {}) {
  return (
    dealOptionWarranties[optionUuid] && dealOptionWarranties[optionUuid][0]
  );
}

function generateBundleCheckoutUrl(dealUuid, optionUuid, warrantyOption) {
  const { warrantyOptionUuid } = warrantyOption;
  return `/checkout/bundle?type=warranty&items=${dealUuid}:${optionUuid}&bundles=${warrantyOptionUuid}`;
}

module.exports = {
  getFirstWarrantyOption,
  generateBundleCheckoutUrl,
};
